import 'summernote/dist/summernote-lite'

const onPaste = function (event) {
    const bufferText = ((event.originalEvent || event).clipboardData || window.clipboardData).getData('text')

    event.preventDefault()

    const text = '<p>' + bufferText.replace(/\n/g, '</p><p>') + '</p>'

    $(this).summernote('pasteHTML', text)
}

const onImageUpload = function (files) {
    var $summernote = $(this)
    var reader = new FileReader()

    reader.onloadend = function () {
        var $img = $('<img>').attr({ src: reader.result, width: '100%' })
        $summernote.summernote('insertNode', $img[0])
    }

    reader.readAsDataURL(files[0])
}

const presets = {
    full: {
        toolbar: [
            ['style', ['style']],
            ['font', ['bold', 'underline', 'clear']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['insert', ['link', 'picture']],
            ['table', ['table']],
            ['view', ['codeview']],
        ],
        popover: {
            table: [
                ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
                ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
            ],
            image: [
                ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
                ['float', ['floatLeft', 'floatRight', 'floatNone']],
                ['remove', ['removeMedia']],
            ],
            link: [['link', ['linkDialogShow', 'unlink']]],
        },
        styleTags: ['p', 'h3', 'h4', 'h5', 'h6'],
    },
    standard: {
        toolbar: [
            ['style', ['style']],
            ['font', ['bold', 'underline', 'clear']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['insert', ['link']],
        ],
        popover: [],
        styleTags: ['p', 'h4', 'h5', 'h6'],
    },
    minimal: {
        toolbar: [
            ['font', ['bold', 'underline', 'clear']],
            ['para', ['ul', 'ol', 'paragraph']],
        ],
        popover: [],
        styleTags: [],
    },
}

export default function initSummernote(preset = 'full') {
    $(() => {
        $('textarea.summernote').each(function () {
            const $el = $(this)
            const config = presets[preset]

            const hasImages =
                preset === 'full' ? !$el.data('summernote-no-picture') : !!$el.data('summernote-insert-picture')

            const toolbar = config.toolbar
                .map(group => {
                    if (group[0] === 'insert') {
                        const items = group[1]
                            .map(item => (item === 'picture' ? (hasImages ? 'picture' : null) : item))
                            .filter(Boolean)
                        return items.length ? ['insert', items] : null
                    }
                    return group
                })
                .filter(Boolean)

            $el.summernote({
                lang: 'fr-FR',
                disableDragAndDrop: true,
                linkAddNoReferrer: true,
                linkAddNoOpener: true,
                toolbar,
                popover: config.popover,
                ...(config.styleTags.length ? { styleTags: config.styleTags } : {}),
                callbacks: {
                    ...(hasImages ? { onImageUpload } : {}),
                    onPaste,
                },
            })
        })
    })
}
